export default __webpack_public_path__ + "21125ca63d0cbaeb240a76046747a165.png";